var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "show-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "custom-class": "checklist-modal",
            "append-to-body": true,
          },
          on: { "update:visible": _vm.updateVisible },
        },
        [
          _c(
            "el-form",
            {
              ref: "checklistForm",
              staticClass: "form",
              attrs: {
                model: _vm.checklistForm,
                rules: _vm.checklistFormRules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("h2", [_vm._v("Add to checklist")]),
              _vm._v(" "),
              _vm.checklists && _vm.checklists.length > 0
                ? [
                    _c("h3", [
                      _vm._v("Which checklist do you want to add this to?"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "useExistingChecklist" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.changeChecklistType },
                            model: {
                              value: _vm.checklistForm.useExistingChecklist,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.checklistForm,
                                  "useExistingChecklist",
                                  $$v
                                )
                              },
                              expression: "checklistForm.useExistingChecklist",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("Existing checklist"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("Create new checklist"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.checklistForm.useExistingChecklist
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "selectedChecklist" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  "popper-class": "checklist-popper-dropdown",
                                },
                                model: {
                                  value: _vm.checklistForm.selectedChecklist,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.checklistForm,
                                      "selectedChecklist",
                                      $$v
                                    )
                                  },
                                  expression: "checklistForm.selectedChecklist",
                                },
                              },
                              _vm._l(_vm.checklists, function (checklist) {
                                return _c("el-option", {
                                  key: checklist.id,
                                  attrs: {
                                    label: checklist.name,
                                    value: checklist.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldCreateNewChecklist
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "checklistName" } },
                    [
                      _c("el-input", {
                        staticClass: "checklist-name",
                        attrs: { placeholder: "Checklist name" },
                        model: {
                          value: _vm.checklistForm.checklistName,
                          callback: function ($$v) {
                            _vm.$set(_vm.checklistForm, "checklistName", $$v)
                          },
                          expression: "checklistForm.checklistName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.topics && _vm.topics.length > 0
                ? [
                    _c("el-form-item", { attrs: { prop: "selectedTopics" } }, [
                      _c(
                        "div",
                        { staticClass: "topics" },
                        [
                          _c("h3", [
                            _vm._v("Which topics do you want to add?"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "checkbox-hide-box",
                              attrs: {
                                indeterminate: _vm.topicsIsIndeterminate,
                              },
                              on: { change: _vm.handleCheckAllChange },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.topics.length ===
                                    _vm.checklistForm.selectedTopics.length
                                    ? "Deselect all"
                                    : "Select all"
                                ) + "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.checklistForm.selectedTopics,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.checklistForm,
                                    "selectedTopics",
                                    $$v
                                  )
                                },
                                expression: "checklistForm.selectedTopics",
                              },
                            },
                            _vm._l(_vm.topics, function (topic) {
                              return _c("el-checkbox", {
                                key: topic.id,
                                attrs: { label: topic.label, value: topic.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "submit",
                  on: {
                    click: function ($event) {
                      return _vm.submit("checklistForm")
                    },
                  },
                },
                [_vm._v("Add to checklist\n      ")]
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }